export default {
    required: (value) => !!value || "This is Required.",
    gst_required: (value) => value != null || "This is Required.",
    required_array: (value) => !!value[0] || "This is Required.",
    email: (v) => {
      /* eslint-disable-next-line no-useless-escape*/
      const re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
      if (re.test(String(v).toLowerCase().trim())) {
        return true;
      }
      return "Invalid Email";
    },
    email_optional: (v) => {
      /* eslint-disable-next-line no-useless-escape*/
      const re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(v).toLowerCase().trim()) || !v) {
        return true;
      }
      return "Invalid Email";
    },
    email2: (v) => {
      /* eslint-disable-next-line no-useless-escape*/
      const re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (v !== null && String(v).trim()) {
        if (re.test(String(v).toLowerCase().trim())) {
          return true;
        }
        return "Invalid Email";
      }
      return true;
    },
    phone: (v) => {
      const re = /^(\+91)?[0]?(91)?[6789]\d{9}$/;
      if (re.test(v)) {
        return true;
      }
      return "Invalid Phone Number";
    },
    phone_optional: (v) => {
      const re = /^(\+91)?[0]?(91)?[6789]\d{9}$/;
      if (v === null || v === "") {
        return true;
      } else if (re.test(v)) {
        return true;
      }
      return "Invalid Phone Number";
    },
    account_number: (v) => {
      // console.log(v)
      const re = /^[0-9]{9,18}$/;
      if (re.test(v)) {
        return true;
      }
      return "Invalid Account Number";
    },
    text: (v) => {
      const re = /^[A-Za-z\s]+$/;
      if (re.test(v)) {
        return true;
      }
      return "Only Character";
    },
    number: (v) => {
      const re = /^[0-9]+$/;
      if (re.test(v)) {
        return true;
      }
      return "Only Numbers";
    },
    url: (v) => {
      const re = /^(http|https):\/\/+[\www\d]+\.[\w]+(\/[\w\d]+)?/;
      if (re.test(v) || !v) {
        return true;
      }
      return "Invalid Url";
    },
    twoDigitValidation: (v) => {
      if (v > 0 && v < 100) {
        return true;
      }
      return "Till two digit Value is accepted";
    },
    threeDigitValidation: (v) => {
      if (v > 0 && v < 1000) {
        return true;
      }
      return "Till three digit Value is accepted";
    },
    aadharValidation: (v) => {
      if (String(v).length === 12) {
        return true;
      }
      return "Invalid Aadhar Number";
    },
    lengthDecimal: (v) => {
      const re = /^[.?]+$/;
  
      if (re.decimal(v)) {
        return true;
      }
      return "Till accepted one digit Value after decimal";
    },
    ifsc_code: (v) => {
      const re = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      if (re.test(v)) {
        return true;
      }
      return "IFSC code must be Alpha Numeric and all the letter should be Capital";
    },
    // account_number: (v) => {
  
    //   const re =/^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$/;
    //   if (re.test(v)) {
    //     return true;
    //   }
    //   return "Invaild Account Number";
    // },
    acc_no: (v) => {
      // console.log("ASD",typeof(v))
      // console.log("ASD",v.toString().length)
      if (
        parseInt(v.toString().length) > 8 &&
        parseInt(v.toString().length) < 18
      ) {
        return true;
      }
      return "Account Number should be between 9-17 digits";
    },
    pan_number: (v) => {
      // console.log(v)
      const re = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (re.test(v)) {
        return true;
      }
      return "Invalid Pan Number";
    },
    gst_number: (v) => {
      const re = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (re.test(v)) {
        return true;
      }
      return "Invalid GST Number";
    },
    weight: (v) => {
      if (parseInt(v) <= 150 || !v) {
        return true;
      }
      return "Weight Should be less than 150KG";
    },
    height:(v)=>{
      if(parseInt(v)<=300 || !v){
        return true
      }
      return "Height Should be less than 300cm"
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberPositive: function (evt) {
      evt = evt ? evt : window.event;
      console.log(evt,"evet")
      // var charCode = evt.which ? evt.which : evt.keyCode;
      // if (
      //   charCode > 31 &&
      //   (charCode < 48 || charCode > 57) &&
      //   charCode !== 46
      // ) {
      //   evt.preventDefault();
      // } else {
      //   return true;
      // }
    },
  };
  